
const mutations = {
    updateTransactionId(state, transactionId) {
        state.transactionId = transactionId;
    },
    updateMessageDateTime(state, messageDateTime) {
        state.messageDateTime = messageDateTime;
    },
    updateVersion(state, version) {
        state.version = version;
    },
    updateAnonymized(state, anonymized) {
        state.anonymized = anonymized;
    },
    updatePoslogApi(state, poslogApi) {
        state.poslogApi = poslogApi
    },
    updateXml(state, xml) {
        state.xml = xml;
    },
    updateDownloadMeta(state, downloadMeta) {
        state.downloadMeta = downloadMeta;
    },
    updateLang(state, lang) {
        state.lang = lang;
    },
    updateCurrentView(state, currentView) {
        state.currentView = currentView;
    },
    updateHistory(state, history) {
        state.history = history;
    }
};

export default mutations;
